<template>
  <div>
    <v-row
      v-for="(fail, i) in questionlist"
      :key="fail.questionID"
      :id="fail.questionID"
    >
      <v-col cols="12" v-if="NoQuestionSearch.length !== 0">
        <v-card>
          <QuestionLabel
            type="fail"
            :label="fail"
            :visible="fail.show"
            :index="i"
            :questionlist="questionlist"
            :NextQuestion="{ questionID: null }"
            :surveyStatus="surveyStatus"
          >
          </QuestionLabel>
        </v-card>
      </v-col>
    </v-row>
    <v-card
      v-if="NoQuestionSearch.length === 0"
      class="d-flex justify-center py-2"
    >
      ไม่พบคำถามที่เกี่ยวข้องกับการค้นหา
    </v-card>
  </div>
</template>

<script>
import QuestionLabel from "./QuestionLabel";
export default {
  props: ["questionlist", "surveyStatus"],
  components: { QuestionLabel },
  computed: {
    NoQuestionSearch() {
      return this.questionlist.filter((show) => show.show);
    },
  },
};
</script>

<style lang="scss" scoped></style>
